<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12">
        <p class="font--p-3 mt-5 mb-10">
          선정산/대출금을 받으시는<br>주거래 계좌
        </p>

        <div class="account-info">
          <div class="info-row">
            <label class="font-size--16">계좌번호</label>
            <div class="value">{{ me.withdrawalAccount.accountNumber }}</div>
          </div>

          <div class="info-row">
            <label class="font-size--16">은행</label>
            <div class="value">{{ getBankName(me.withdrawalAccount.bank) }}</div>
          </div>

          <div class="info-row">
            <label class="font-size--16">예금주</label>
            <div class="value">{{ me.withdrawalAccount.holderName }}</div>
          </div>
        </div>

        <div class="d-flex mt-8 button-group">
          <BasicButton
            class="change-button"
            @click="goToWithdrawal"
          >
            계좌 변경하기
          </BasicButton>
          
          <v-btn
            small
            outlined
            class="close-btn"
            @click="closeAndGoBack"
          >
            닫기
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    me: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      banksObj: {},
    }
  },
  async created() {
    this.banksObj = await this.getBanks()
  },
  methods: {
    ...mapActions('choice', ['getBanks']),
    getBankName(bankCode) {
      return this.banksObj[bankCode] || bankCode
    },
    goToWithdrawal() {
      this.$router.push({
        path: '/bank/withdrawal',
        query: { next: '/bank/withdrawal-info' }  // 계좌 등록 후 돌아갈 경로 지정
      })
    },
    closeAndGoBack() {
      this.$router.push('/earlypay')
    }
  }
}
</script>

<style lang="scss" scoped>
.account-info {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 20px;

  .info-row {
    margin-bottom: 20px;
    
    &:last-child {
      margin-bottom: 0;
    }

    label {
      display: block;
      color: #666;
      margin-bottom: 8px;
    }

    .value {
      font-size: 16px;
      font-weight: 500;
      color: #333;
    }
  }
}

.button-group {
  display: flex;
  gap: 8px;
  width: 100%;

  .change-button {
    flex: 1;
  }
  
  .close-btn {
    width: 80px !important;
    height: 52px !important;
    background-color: white !important;
    border: 1px solid #ddd !important;
    color: #333 !important;
    text-transform: none !important;
    font-size: 16px !important;
    letter-spacing: -0.3px;
  }
}

:deep(.btn--white) {
  color: #333 !important;
}
</style>
